import { ColorPicker, Popover, Tooltip } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconPalette } from '@tabler/icons';
import { useCurrentEditor } from '@tiptap/react';
import { FC } from 'react';
import ActionIconWithoutFocus from '../../../../Atoms/ActionIconWithoutFocus';
import { DataS } from '../../../../Service/DataS';

const ToolbarColorIcon: FC<{ includeTooltip?: boolean }> = ({ includeTooltip = true }) => {
  const [opened, { toggle }] = useDisclosure(false);
  const { editor } = useCurrentEditor();

  const onColorPicked = (color: string) => {
    if (editor) editor.chain().focus().setColor(color).run();
  };

  return (
    <Popover returnFocus opened={opened} onChange={toggle} position="top">
      <Popover.Target>
        <Tooltip withArrow disabled={!includeTooltip} openDelay={300} transition="slide-up" label="Farbe">
          <div>
            <ActionIconWithoutFocus variant="subtle" onClick={toggle}>
              <IconPalette size={20} />
            </ActionIconWithoutFocus>
          </div>
        </Tooltip>
      </Popover.Target>
      <Popover.Dropdown p={5} sx={{ boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;' }}>
        <ColorPicker swatches={DataS.defaultColorSwatches} onChangeEnd={onColorPicked} />
      </Popover.Dropdown>
    </Popover>
  );
};

export default ToolbarColorIcon;
